<div class="row">
    <div class="col-12">
        <div class="plans-toggler mb-5" (click)="changeSubscriptionView()">
            <div [ngClass]="!showSubscriptions ? 'active' : ''" class="plan-btn pointer mx-1">
                Evaluaciones psicométricas
            </div>
            <div [ngClass]="showSubscriptions ? 'active' : ''" class="plan-btn pointer mx-1">
                Evaluaciones cognitivo-laboral
            </div>
        </div>
        <div *ngIf="plans.length>0&&country && !showSubscriptions" class="card">
            <div class="card-body">
              <p class="mb-1 text-center text-bold"><b>Todos los planes incluyen las pruebas:</b></p>
              <p class="mb-0 text-center">Cleaver, Terman, Allport, Kostick, 16PF, IPV, Zavic, Barsit, MMPI-2, MMPI-A, MIPS, BIS-11, Chaside, Domino</p>
                <div class="row pricing-plan jcc">
                    <div class="col-md-2 col-xs-12 col-sm-6 no-padding">
                        <div class="pricing-box">
                            <div class="pricing-body b-l">
                                <div class="pricing-header">
                                    <h4 class="text-center">Starter</h4>
                                    <h2 *ngIf="country=='AR'" class="text-center"><span class="price-sign">$</span>{{plans[0].price | currency:' ':false:'1.0-0'}}</h2>
                                    <p *ngIf="country=='AR'" class="uppercase">ars</p>
                                    <h2 *ngIf="country=='MX'" class="text-center"><span class="price-sign">$</span>{{plans[0].mxn}}</h2>
                                    <p *ngIf="country=='MX'" class="uppercase">mxn</p>
                                    <h2 *ngIf="country=='ES'" class="text-center"><span class="price-sign">$</span>{{plans[0].eur}}</h2>
                                    <p *ngIf="country=='ES'" class="uppercase">eur</p>
                                    <h2 *ngIf="country!='AR'&&country!='MX'&&country!='ES'" class="text-center"><span class="price-sign">$</span>{{plans[0].usd}}</h2>
                                    <p *ngIf="country!='AR'&&country!='MX'&&country!='ES'" class="uppercase">usd</p>
                                </div>
                                <div class="price-table-content">
                                    <div class="price-row"><i class="icon-user"></i> {{plans[0].tests}} Usos</div>
                                    <!-- <div class="price-row">
                                        <p class="m-0">Cleaver, Terman, All Port, Kostick,</p>
                                        <p>16PF, IPV, Zavic, Barsit, MMPI-2, MMPI-A, MIPS, BIS-11, Chaside, Domino</p>
                                    </div> -->
                                    <div class="price-row"><i class=" icon-clock"></i> 1 Año</div>
                                    <div class="price-row"> -- </div>

                                    <div class="price-row">
                                        <div style="margin:10px" *ngIf="country!='AR'" #paypal0></div>
                                        <button *ngIf="country=='AR'" class="btn btn-info btn-rounded waves-effect waves-light m-t-20" (click)="mpBuy(plans[0])">COMPRAR</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 col-xs-12 col-sm-6 no-padding">
                        <div class="pricing-box b-l">
                            <div class="pricing-body">
                                <div class="pricing-header">
                                    <h4 class="text-center">Professional</h4>
                                    <h2 *ngIf="country=='AR'" class="text-center"><span class="price-sign">$</span>{{plans[1].price | currency:' ':false:'1.0-0'}}</h2>
                                    <p *ngIf="country=='AR'" class="uppercase">ars</p>
                                    <h2 *ngIf="country=='MX'" class="text-center"><span class="price-sign">$</span>{{plans[1].mxn}}</h2>
                                    <p *ngIf="country=='MX'" class="uppercase">mxn</p>
                                    <h2 *ngIf="country=='ES'" class="text-center"><span class="price-sign">$</span>{{plans[1].eur}}</h2>
                                    <p *ngIf="country=='ES'" class="uppercase">eur</p>
                                    <h2 *ngIf="country!='AR'&&country!='MX'&&country!='ES'" class="text-center"><span class="price-sign">$</span>{{plans[1].usd}}</h2>
                                    <p *ngIf="country!='AR'&&country!='MX'&&country!='ES'" class="uppercase">usd</p>
                                </div>
                                <div class="price-table-content">
                                    <div class="price-row"><i class="icon-user"></i> {{plans[1].tests}} Usos</div>
                                    <!-- <div class="price-row">
                                        <p class="m-0">Cleaver, Terman, All Port, Kostick,</p>
                                        <p>16PF, IPV, Zavic, Barsit, MMPI-2, MMPI-A, MIPS, BIS-11, Chaside, Domino</p>
                                    </div> -->
                                    <div class="price-row"><i class=" icon-clock"></i> 1 Año</div>
                                    <div class="price-row"> -- </div>

                                    <div class="price-row">
                                        <div style="margin:10px" *ngIf="country!='AR'" #paypal1></div>
                                        <button *ngIf="country=='AR'" class="btn btn-info btn-rounded waves-effect waves-light m-t-20" (click)="mpBuy(plans[1])">COMPRAR</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 col-xs-12 col-sm-6 no-padding">
                        <div class="pricing-box b-l b-r">
                            <div class="pricing-body">
                                <div class="pricing-header">
                                     <h4 class="text-center">Premium</h4>
                                    <h2 *ngIf="country=='AR'" class="text-center"><span class="price-sign">$</span>{{plans[2].price | currency:' ':false:'1.0-0'}}</h2>
                                    <p *ngIf="country=='AR'" class="uppercase">ars</p>
                                    <h2 *ngIf="country=='MX'" class="text-center"><span class="price-sign">$</span>{{plans[2].mxn}}</h2>
                                    <p *ngIf="country=='MX'" class="uppercase">mxn</p>
                                    <h2 *ngIf="country=='ES'" class="text-center"><span class="price-sign">$</span>{{plans[2].eur}}</h2>
                                    <p *ngIf="country=='ES'" class="uppercase">eur</p>
                                    <h2 *ngIf="country!='AR'&&country!='MX'&&country!='ES'" class="text-center"><span class="price-sign">$</span>{{plans[2].usd}}</h2>         
                                    <p *ngIf="country!='AR'&&country!='MX'&&country!='ES'" class="uppercase">usd</p>
                                </div>
                                <div class="price-table-content">
                                    <div class="price-row"><i class="icon-user"></i> {{plans[2].tests}} Usos</div>
                                    <!-- <div class="price-row">
                                        <p class="m-0">Cleaver, Terman, All Port, Kostick,</p>
                                        <p>16PF, IPV, Zavic, Barsit, MMPI-2, MMPI-A, MIPS, BIS-11, Chaside, Domino</p>
                                    </div> -->
                                    <div class="price-row"><i class=" icon-clock"></i> 1 Año</div>
                                    <div class="price-row"> -- </div>

                                    <div class="price-row">
                                        <div style="margin:10px" *ngIf="country!='AR'" #paypal2></div>
                                        <button *ngIf="country=='AR'" class="btn btn-info btn-rounded waves-effect waves-light m-t-20" (click)="mpBuy(plans[2])">COMPRAR</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 col-xs-12 col-sm-6 no-padding">
                        <div class="pricing-box b-l b-r">
                            <div class="pricing-body b-r">
                                <div class="pricing-header">
                                    <h4 class="text-center">Vip</h4>
                                    <h2 *ngIf="country=='AR'" class="text-center"><span class="price-sign">$</span>{{plans[3].price | currency:' ':false:'1.0-0'}}</h2>
                                    <p *ngIf="country=='AR'" class="uppercase">ars</p>
                                    <h2 *ngIf="country=='MX'" class="text-center"><span class="price-sign">$</span>{{plans[3].mxn}}</h2>
                                    <p *ngIf="country=='MX'" class="uppercase">mxn</p>
                                    <h2 *ngIf="country=='ES'" class="text-center"><span class="price-sign">$</span>{{plans[3].eur}}</h2>
                                    <p *ngIf="country=='ES'" class="uppercase">eur</p>
                                    <h2 *ngIf="country!='AR'&&country!='MX'&&country!='ES'" class="text-center"><span class="price-sign">$</span>{{plans[3].usd}}</h2>                                    
                                    <p *ngIf="country!='AR'&&country!='MX'&&country!='ES'" class="uppercase">usd</p>
                                </div>
                                <div class="price-table-content">
                                    <div class="price-row"><i class="icon-user"></i> {{plans[3].tests}} Usos</div>
                                    <!-- <div class="price-row">
                                        <p class="m-0">Cleaver, Terman, All Port, Kostick,</p>
                                        <p>16PF, IPV, Zavic, Barsit, MMPI-2, MMPI-A, MIPS, BIS-11, Chaside, Domino</p>
                                    </div> -->
                                    <div class="price-row"><i class=" icon-clock"></i> ILIMITADO</div>
                                    <div class="price-row"> -- </div>

                                    <div class="price-row">
                                        <div style="margin:10px" *ngIf="country!='AR'" #paypal3></div>
                                        <button *ngIf="country=='AR'" class="btn btn-info btn-rounded waves-effect waves-light m-t-20" (click)="mpBuy(plans[3])">COMPRAR</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 col-xs-12 col-sm-6 no-padding">
                      <div class="pricing-box">
                          <div class="pricing-body b-r">
                              <div class="pricing-header">
                                  <h4 class="text-center">White Label</h4>
                                  <h2 *ngIf="country=='AR'" class="text-center"><span class="price-sign">$</span>{{plans[4].price | currency:' ':false:'1.0-0'}}</h2>
                                  <p *ngIf="country=='AR'" class="uppercase">ars</p>
                                  <h2 *ngIf="country=='MX'" class="text-center"><span class="price-sign">$</span>{{plans[4].mxn}}</h2>
                                  <p *ngIf="country=='MX'" class="uppercase">mxn</p>
                                  <h2 *ngIf="country=='ES'" class="text-center"><span class="price-sign">$</span>{{plans[4].eur}}</h2>
                                  <p *ngIf="country=='ES'" class="uppercase">eur</p>
                                  <h2 *ngIf="country!='AR'&&country!='MX'&&country!='ES'" class="text-center"><span class="price-sign">$</span>{{plans[4].usd}}</h2>                                    
                                  <p *ngIf="country!='AR'&&country!='MX'&&country!='ES'" class="uppercase">usd</p>
                              </div>
                              <div class="price-table-content">
                                  <div class="price-row"><i class="icon-user"></i> {{plans[4].tests}} Usos</div>
                                  <!-- <div class="price-row">
                                      <p class="m-0">Cleaver, Terman, All Port, Kostick,</p>
                                      <p>16PF, IPV, Zavic, Barsit, MMPI-2, MMPI-A, MIPS, BIS-11, Chaside, Domino</p>
                                  </div> -->
                                  <div class="price-row"><i class=" icon-clock"></i> 1 Año</div>
                                  <div class="price-row"><i class=" icon-check"></i> <b> Tu logo *</b></div>

                                  <div class="price-row">
                                      <div style="margin:10px" *ngIf="country!='AR'" #paypal4></div>
                                      <button *ngIf="country=='AR'" class="btn btn-info btn-rounded waves-effect waves-light m-t-20" (click)="mpBuy(plans[4])">COMPRAR</button>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                </div>
            </div>

            <p class="px-5"><b class="text-bold">*White Label:</b></p>
            <p class="px-5">
              <b class="text-bold">● Logo: </b>El plan permite usar su propio logo y colores de branding en los paneles de acceso y login de evaluadores y evaluados.
            </p>

            <p class="px-5">
              <b class="text-bold">● Anonimato: </b>Ofrece la opción de login en nuestro dominio o uno genérico/anónimo, evitando que evaluadores y evaluados identifiquen nuestra marca en el login o el dominio.
            </p>

            <br>

            <p class="px-5">
              <b class="text-bold"><i class=" icon-clock"></i> Vigencia de Uso: </b>El plan permite elegir entre vigencia anual o ilimitada para consumir usos o créditos asignados.
            </p>

            <!-- <div id="paypal-button-container-P-9KW143031P3347142M6DUT4Q"></div>
            <script src="https://www.paypal.com/sdk/js?client-id=AYMNi-jWIEsA-Vm7EfjR9P1SmtY90szODsOBfjafSLq4hM1XTE23a7J2VCkNrvyAZHL7gCqNefGtpQ3F&vault=true&intent=subscription" data-sdk-integration-source="button-factory"></script>
            <script>
            paypal.Buttons({
                style: {
                    shape: 'rect',
                    color: 'gold',
                    layout: 'vertical',
                    label: 'subscribe'
                },
                createSubscription: function(data, actions) {
                    return actions.subscription.create({
                    /* Creates the subscription */
                    plan_id: 'P-9KW143031P3347142M6DUT4Q'
                    });
                },
                onApprove: function(data, actions) {
                    alert(data.subscriptionID); // You can add optional success message for the subscriber here
                }
            }).render('#paypal-button-container-P-9KW143031P3347142M6DUT4Q'); // Renders the PayPal button
            </script> -->
        </div>

        <div *ngIf="plans.length>0&&country && showSubscriptions && !anual" class="card">
            <div class="card-body">
              <p class="mb-1 text-center text-bold" ><b>Pruebas cognitivo - laboral </b></p>
              <div class="row jcc mt-3">
                  <div class="col-12 col-md-3" (click)="changeAnual()" >
                    <div class="row">
                        <div [ngClass]="!anual ? 'selected' : ''" class="col-6 left-toggle">
                            Mensual
                        </div>
                        <div [ngClass]="anual ? 'selected' : ''" class="right-toggle">
                            Anual
                        </div>
                    </div>
                  </div>
              </div>
              <!-- <p class="mb-0 text-center">Cleaver, Terman, Allport, Kostick, 16PF, IPV, Zavic, Barsit, MMPI-2, MMPI-A, MIPS, BIS-11, Chaside, Domino</p> -->
                <div class="row pricing-plan jcc">
                    <div class="col-md-2 col-xs-12 col-sm-6 no-padding">
                        <div class="pricing-box">
                            <div class="pricing-body b-l">
                                <div class="pricing-header">
                                    <h4 class="text-center">Evaluaciones cognitivo - laboral</h4>
                                    <!-- <h2 *ngIf="country=='AR'" class="text-center"><span class="price-sign">$</span>25.000</h2> -->
                                    <h2 *ngIf="country=='AR'" class="text-center"><span class="price-sign">$</span>{{plans[5].price | currency:' ':false:'1.0-0'}}</h2>
                                    <p *ngIf="country=='AR'" class="uppercase">ars</p>
                                    <h2 *ngIf="country=='MX'" class="text-center"><span class="price-sign">$</span>{{plans[5].mxn}}</h2>
                                    <p *ngIf="country=='MX'" class="uppercase">mxn</p>
                                    <h2 *ngIf="country=='ES'" class="text-center"><span class="price-sign">$</span>{{plans[5].eur}}</h2>
                                    <p *ngIf="country=='ES'" class="uppercase">eur</p>
                                    <h2 *ngIf="country!='AR'&&country!='MX'&&country!='ES'" class="text-center"><span class="price-sign">$</span>{{plans[5].usd}}</h2>
                                    <p *ngIf="country!='AR'&&country!='MX'&&country!='ES'" class="uppercase">usd</p>
                                </div>
                                <div class="price-table-content">
                                    <!-- <div class="price-row"><i class="icon-user"></i> {{plans[0].tests}} Usos</div> -->
                                    <!-- <div class="price-row">
                                        <p class="m-0">Cleaver, Terman, All Port, Kostick,</p>
                                        <p>16PF, IPV, Zavic, Barsit, MMPI-2, MMPI-A, MIPS, BIS-11, Chaside, Domino</p>
                                    </div> -->
                                    <div class="price-row"><i class=" icon-clock"></i> 1 mes</div>
                                    <!-- <div class="price-row"> -- </div> -->

                                    <div class="price-row">
                                        <div style="margin:10px" *ngIf="country!='AR'" id="month-test-paypal"></div>
                                        <button *ngIf="country=='AR'" class="btn btn-info btn-rounded waves-effect waves-light m-t-20" (click)="mpSubscription('monthly', plans[5].price)">COMPRAR</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 col-xs-12 col-sm-6 no-padding">
                        <div class="pricing-box b-l">
                            <div class="pricing-body">
                                <div class="pricing-header">
                                    <h4 class="text-center">Evaluaciones + Creador de evaluaciones</h4>
                                    <h2 *ngIf="country=='AR'" class="text-center"><span class="price-sign">$</span>{{plans[6].price | currency:' ':false:'1.0-0'}}</h2>
                                    <p *ngIf="country=='AR'" class="uppercase">ars</p>
                                    <h2 *ngIf="country=='MX'" class="text-center"><span class="price-sign">$</span>{{plans[6].mxn}}</h2>
                                    <p *ngIf="country=='MX'" class="uppercase">mxn</p>
                                    <h2 *ngIf="country=='ES'" class="text-center"><span class="price-sign">$</span>{{plans[6].eur}}</h2>
                                    <p *ngIf="country=='ES'" class="uppercase">eur</p>
                                    <h2 *ngIf="country!='AR'&&country!='MX'&&country!='ES'" class="text-center"><span class="price-sign">$</span>{{plans[6].usd}}</h2>
                                    <p *ngIf="country!='AR'&&country!='MX'&&country!='ES'" class="uppercase">usd</p>
                                </div>
                                <div class="price-table-content">
                                    <!-- <div class="price-row"><i class="icon-user"></i> {{plans[1].tests}} Usos</div> -->
                                    <!-- <div class="price-row">
                                        <p class="m-0">Cleaver, Terman, All Port, Kostick,</p>
                                        <p>16PF, IPV, Zavic, Barsit, MMPI-2, MMPI-A, MIPS, BIS-11, Chaside, Domino</p>
                                    </div> -->
                                    <div class="price-row"><i class=" icon-clock"></i> 1 mes</div>
                                    <!-- <div class="price-row"> -- </div> -->

                                    <div class="price-row">
                                        <div style="margin:10px" *ngIf="country!='AR'" id="month-creator-paypal"></div>
                                        
                                        <button *ngIf="country=='AR'" class="btn btn-info btn-rounded waves-effect waves-light m-t-20" (click)="mpSubscription('monthly', plans[6].price, true)">COMPRAR</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>

        </div>

        <div *ngIf="plans.length>0&&country && showSubscriptions && anual" class="card">
            <div class="card-body">
              <p class="mb-1 text-center text-bold"><b>Pruebas cognitivo - laboral</b></p>
              <div class="row jcc mt-3">
                <div class="col-12 col-md-3" (click)="changeAnual()" >
                  <div class="row">
                      <div [ngClass]="!anual ? 'selected' : ''" class="col-6 left-toggle">
                          Mensual
                      </div>
                      <div [ngClass]="anual ? 'selected' : ''" class="right-toggle">
                          Anual
                      </div>
                  </div>
                </div>
            </div>
                <div class="row pricing-plan jcc">
                    <div class="col-md-2 col-xs-12 col-sm-6 no-padding">
                        <div class="pricing-box">
                            <div class="pricing-body b-l">
                                <div class="pricing-header">
                                    <h4 class="text-center">Evaluaciones cognitivo - laboral</h4>
                                    <h2 *ngIf="country=='AR'" class="text-center"><span class="price-sign">$</span>{{plans[7].price | currency:' ':false:'1.0-0'}}</h2>
                                    <p *ngIf="country=='AR'" class="uppercase">ars</p>
                                    <p *ngIf="country=='AR'" class="uppercase"><b>Ahorro {{plans[7].saveArs | currency:'$':false:'1.0-0'}}</b></p>
                                    <h2 *ngIf="country=='MX'" class="text-center"><span class="price-sign">$</span>{{plans[7].mxn}}</h2>
                                    <p *ngIf="country=='MX'" class="uppercase">mxn</p>
                                    <p *ngIf="country=='MX'" class="uppercase"><b>Ahorro ${{plans[7].saveMxn}}</b></p>
                                    <h2 *ngIf="country=='ES'" class="text-center"><span class="price-sign">$</span>{{plans[7].eur}}</h2>
                                    <p *ngIf="country=='ES'" class="uppercase">eur</p>
                                    <p *ngIf="country=='ES'" class="uppercase"><b>Ahorro ${{plans[7].saveEur}}</b></p>
                                    <h2 *ngIf="country!='AR'&&country!='MX'&&country!='ES'" class="text-center"><span class="price-sign">$</span>{{plans[7].usd}}</h2>
                                    <p *ngIf="country!='AR'&&country!='MX'&&country!='ES'" class="uppercase">usd</p>
                                    <p *ngIf="country!='AR'&&country!='MX'&&country!='ES'" class="uppercase"><b>Ahorro ${{plans[7].saveUsd}}</b></p>

                                </div>
                                <div class="price-table-content">
                                    <!-- <div class="price-row"><i class="icon-user"></i> {{plans[0].tests}} Usos</div> -->
                                    <!-- <div class="price-row">
                                        <p class="m-0">Cleaver, Terman, All Port, Kostick,</p>
                                        <p>16PF, IPV, Zavic, Barsit, MMPI-2, MMPI-A, MIPS, BIS-11, Chaside, Domino</p>
                                    </div> -->
                                    <div class="price-row"><i class=" icon-clock"></i> 1 año</div>
                                    <!-- <div class="price-row"> -- </div> -->

                                    <div class="price-row">
                                        <div style="margin:10px" *ngIf="country!='AR'" id="anual-test-paypal"></div>
                                        <button *ngIf="country=='AR'" class="btn btn-info btn-rounded waves-effect waves-light m-t-20" (click)="mpSubscription('anual', plans[7].price)">COMPRAR</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 col-xs-12 col-sm-6 no-padding">
                        <div class="pricing-box b-l">
                            <div class="pricing-body">
                                <div class="pricing-header">
                                    <h4 class="text-center">Evaluaciones + Creador de evaluaciones</h4>
                                    <h2 *ngIf="country=='AR'" class="text-center"><span class="price-sign">$</span>{{plans[8].price | currency:' ':false:'1.0-0'}}</h2>
                                    <p *ngIf="country=='AR'" class="uppercase">ars</p>
                                    <p *ngIf="country=='AR'" class="uppercase"><b>Ahorro {{plans[8].saveArs | currency:'$':false:'1.0-0'}}</b></p>

                                    <h2 *ngIf="country=='MX'" class="text-center"><span class="price-sign">$</span>{{plans[8].mxn}}</h2>
                                    <p *ngIf="country=='MX'" class="uppercase">mxn</p>
                                    <p *ngIf="country=='MX'" class="uppercase"><b>Ahorro ${{plans[8].saveMxn}}</b></p>

                                    <h2 *ngIf="country=='ES'" class="text-center"><span class="price-sign">$</span>{{plans[8].eur}}</h2>
                                    <p *ngIf="country=='ES'" class="uppercase">eur</p>
                                    <p *ngIf="country=='ES'" class="uppercase"><b>Ahorro ${{plans[8].saveEur}}</b></p>

                                    <h2 *ngIf="country!='AR'&&country!='MX'&&country!='ES'" class="text-center"><span class="price-sign">$</span>{{plans[8].usd}}</h2>
                                    <p *ngIf="country!='AR'&&country!='MX'&&country!='ES'" class="uppercase">usd</p>
                                    <p *ngIf="country!='AR'&&country!='MX'&&country!='ES'" class="uppercase"><b>Ahorro ${{plans[8].saveUsd}}</b></p>

                                </div>
                                <div class="price-table-content">
                                    <!-- <div class="price-row"><i class="icon-user"></i> {{plans[1].tests}} Usos</div> -->
                                    <!-- <div class="price-row">
                                        <p class="m-0">Cleaver, Terman, All Port, Kostick,</p>
                                        <p>16PF, IPV, Zavic, Barsit, MMPI-2, MMPI-A, MIPS, BIS-11, Chaside, Domino</p>
                                    </div> -->
                                    <div class="price-row"><i class=" icon-clock"></i> 1 año</div>
                                    <!-- <div class="price-row"> -- </div> -->

                                    <div class="price-row">
                                        <div style="margin:10px" *ngIf="country!='AR'" id="anual-creator-paypal"></div>

                                        <button *ngIf="country=='AR'" class="btn btn-info btn-rounded waves-effect waves-light m-t-20" (click)="mpSubscription('anual', plans[8].price, true)">COMPRAR</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>

        </div>
    </div>
</div>


<div id="loadingModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none;">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
                <h3>Trabajando. No cierres esta ventana</h3>
                <div class="row justify-content-center">
                    <img src="../../../assets/images/loading.gif" alt="">
                </div>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
